import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SaveSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SaveSVG;
